import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';
import { api } from '@/api';
import { PaginationSearchParams } from '@/api/types';
import { PaginatedRegionListFilters } from '@/api/apis/facilities';
import { regionsQueryKeys, serviceRegionsQueryKeys } from '@/queries/regions/regions.keys';

const allRegionsPaginationParams: PaginationSearchParams = {
  itemsPerPage: 100,
  pageIndex: 0,
};

export const regionsQueries = {
  all: () =>
    queryOptions({
      queryKey: regionsQueryKeys.getList(allRegionsPaginationParams),
      queryFn: () => api.regions.getRegionsList(allRegionsPaginationParams),
      staleTime: Infinity,
    }),
  list: (listQuery: PaginatedRegionListFilters) =>
    queryOptions({
      queryKey: regionsQueryKeys.getList(listQuery),
      queryFn: () => api.regions.getRegionsListV2(listQuery),
      placeholderData: keepPreviousData,
    }),
  item: (regionId: string) =>
    queryOptions({
      queryKey: regionsQueryKeys.getItem(regionId),
      queryFn: () => api.regions.getRegionById(regionId),
    }),
  serviceRegions: () =>
    queryOptions({
      queryKey: serviceRegionsQueryKeys.getList(),
      queryFn: () => api.regions.getServiceRegionsList(),
      staleTime: Infinity,
    }),
};

export const useAllRegionsListQuery = () => {
  return useQuery(regionsQueries.all());
};

export const useRegionListQuery = (listQuery: PaginatedRegionListFilters) => {
  return useQuery(regionsQueries.list(listQuery));
};

export const useRegionItemByIdQuery = (regionId: string) => {
  return useQuery(regionsQueries.item(regionId));
};
export const useServiceRegionsListQuery = () => {
  return useQuery(regionsQueries.serviceRegions());
};
